<template>
  <div :class="'ali-select'+(multiple?' multiple':'')" @click="openModal">
    <div v-if="!selectedItems.length">
      <strong>{{ desc ? desc : 'برای انتخاب کلیک کنید' }}</strong>
    </div>
    <div class="selected-item" v-for="item in selectedItems" :key="item">
      {{ item[itemTitle] }}
      <input type="hidden" :name="name+(multiple?'[]':'')"
             :value="item[itemId]">
    </div>
  </div>
</template>

<script>
import {modalController} from '@ionic/vue';
import Modal from './selectModal'

export default {
  mounted()
  {
    const self = this;
    window.onpopstate = function ()
    {
      if (self.modal)
      {
        self.hardClose = true
        self.modal.dismiss();
      }
    };

    if (this.selected && Array.isArray(this.selected))
    {
      for (let i=0;i<this.selected.length;i++)
      {
        this.selectedItems.push(this.selected[i]);
      }
    }
  },
  data: () =>
  {
    return {
      hardClose: false,
      selectedItems: [],
      modal: null,
      search: true,
      items:[]
    }
  },
  methods: {
    searchInSelectedItems:function (itemId)
    {
      for (let i=0;i<this.selectedItems.length;i++)
      {
        if (this.selectedItems[i][this.itemId]===itemId)
        {
          return true;
        }
      }
      return false
    },
    getSelectedItems:function ()
    {
      return this.selectedItems;
    },
    setSelected: function (event,items)
    {
      const wasSelected = event.target.classList.contains('active');
      event.target.classList.toggle('active');
      const id = event.target.getAttribute('data-value');
      if (wasSelected)
      {
        for (let i=0;i<this.selectedItems.length;i++)
        {
          if (this.selectedItems[i][this.itemId]===id)
            this.selectedItems.splice(i,1);
        }
      }
      else
      {
        for (let i = 0; i < items.length; i++)
        {
          if (items[i][this.itemId] === id)
          {
            if (this.multiple)
            {
              this.selectedItems.push(items[i]);
            }
            else
            {
              this.selectedItems = [items[i]];
              if (this.modal)
              {
                this.modal.dismiss()
              }
            }
            break;
          }
        }
      }

      if (typeof this.onChange==='function')
      {
        this.onChange(this.selectedItems,this.index)
      }
    },
    async openModal()
    {
      this.modal = await modalController
          .create({
            component: Modal,
            componentProps: {
              items: this.items,
              itemTitle: this.itemTitle,
              itemId: this.itemId,
              title: this.title,
              setSelected: this.setSelected,
              route:this.route,
              search: this.search,
              doSearch:this.doSearch,
              closeModal: this.closeModal,
              getSelectedItems:this.getSelectedItems,
              searchInSelectedItems:this.searchInSelectedItems,
            },

          })
      await this.$router.push({path: '#modalOpen'})

      const state = {'page_id': 1, 'user_id': 5}
      const title = ''
      const url = this.$route.fullPath + '#modalOppened'
      history.pushState(state, title, url);

      const self = this;
      this.modal.onDidDismiss().then(function ()
      {
        if (self.hardClose)
        {
          self.hardClose = false;
        }
        else
        {
          window.history.back();
          setTimeout(function (){
            self.hardClose = false;
          },400)
        }
      })
      this.modal.present();
    },
    closeModal()
    {
      if (this.modal)
      {
        this.modal.dismiss()
      }
    }
  },
  watch:{
    reset:function ()
    {
      this.selectedItems = [];
    }
  },
  props: [
    'itemTitle',
    'itemId',
    'title',
    'multiple',
    'name',
    'selected',
    'route',
    'onChange',
    'index',
    'desc',
    'reset'
  ]
}
</script>

<style scoped>
.ali-select {
  background: #f0f4fb;
  /*border-radius: 8px !important;*/
  padding: 5px;
  width: 100%;
  border: 1px solid gainsboro;
}

.ali-select.multiple .selected-item {
  /*border-radius: 3px !important;*/
  padding: 4px 10px;
  border: 1px solid gainsboro;
  display: inline-block;
  margin-left: 4px;
}
</style>